export const categories = [
  {
    slug: "zhao-bei-ce-liang",
    name: "罩杯尺码测量",
    description: "学会正确测量胸围和罩杯，找到真正适合你的尺码，告别买错内衣的困扰。",
    icon: "ri-ruler-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20editorial%20with%20soft%20measuring%20tape%20on%20cream%20background%2C%20feminine%20aesthetic%2C%20gentle%20natural%20lighting%2C%20clean%20artistic%20composition%20with%20neutral%20beige%20tones&width=600&height=400&seq=cat-zhao-bei-ce-liang&orientation=landscape",
  },
  {
    slug: "jian-dai-zhi-cheng",
    name: "肩带支撑选择",
    description: "不同胸型适合什么样的肩带设计？宽肩带、交叉带、无肩带全解析。",
    icon: "ri-shirt-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20editorial%20with%20fabric%20straps%20on%20warm%20cream%20background%2C%20feminine%20aesthetic%2C%20gentle%20natural%20lighting%2C%20clean%20artistic%20composition%20with%20neutral%20beige%20tones&width=600&height=400&seq=cat-jian-dai-zhi-cheng&orientation=landscape",
  },
  {
    slug: "ri-chang-chuan-da",
    name: "日常穿搭技巧",
    description: "显瘦不压胸的内衣穿搭法则，让你在不同场合都能穿出自信和舒适。",
    icon: "ri-t-shirt-air-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20editorial%20with%20stylish%20outfit%20on%20warm%20cream%20background%2C%20feminine%20aesthetic%2C%20gentle%20natural%20lighting%2C%20clean%20artistic%20composition%20with%20neutral%20beige%20tones&width=600&height=400&seq=cat-ri-chang-chuan-da&orientation=landscape",
  },
  {
    slug: "pin-pai-tui-jian",
    name: "品牌推荐与测评",
    description: "精选大胸友好内衣品牌，涵盖国内外多个价位段，总有一款适合你。",
    icon: "ri-store-2-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20boutique%20fashion%20editorial%20on%20warm%20cream%20background%2C%20feminine%20aesthetic%2C%20gentle%20natural%20lighting%2C%20clean%20artistic%20composition%20with%20neutral%20beige%20tones&width=600&height=400&seq=cat-pin-pai-tui-jian&orientation=landscape",
  },
  {
    slug: "yun-dong-nei-yi",
    name: "运动内衣指南",
    description: "高强度支撑运动内衣选购要点，让你运动时不再受胸部晃动困扰。",
    icon: "ri-heart-pulse-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20activewear%20fashion%20editorial%20on%20warm%20cream%20background%2C%20feminine%20aesthetic%2C%20gentle%20natural%20lighting%2C%20clean%20artistic%20composition%20with%20neutral%20beige%20tones&width=600&height=400&seq=cat-yun-dong-nei-yi&orientation=landscape",
  },
  {
    slug: "bao-yang-hu-li",
    name: "保养护理知识",
    description: "内衣正确清洗、晾晒、收纳方法，延长内衣寿命，保持最佳穿着体验。",
    icon: "ri-drop-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20laundry%20care%20editorial%20on%20warm%20cream%20background%2C%20feminine%20aesthetic%2C%20gentle%20natural%20lighting%2C%20clean%20artistic%20composition%20with%20neutral%20beige%20tones&width=600&height=400&seq=cat-bao-yang-hu-li&orientation=landscape",
  },
];